import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production/ordres-fabrication")({
  staticData: {
    permission: PERMISSIONS.PRODUCTION.OF.VIEW,
  },
  component: () => <Outlet />,
});
